import CIQClient, { HTTPClientResponse } from "services/ciq-client";
import { LINK_RECOMMENDER_FEEDBACK_URL } from "services/endpoints";
import type { TAiLinkTabState } from "../models";
import type { TLinkRecommenderFeedbackRequestItem } from "../utils/ai-link-feedback";
import { BASE_URL } from "config/config";

export type TLinkRecommenderFeedbackResultItem = {
  activity_id: string | null;
  material_id: string;
  tab_state: TAiLinkTabState;
  positive: boolean;
  status: string;
  updated: boolean;
};

export type TLinkRecommenderFeedbackResponse = {
  results: TLinkRecommenderFeedbackResultItem[];
};

export const submitLinkRecommenderFeedback = ({
  items,
  projectToken
}: {
  items: TLinkRecommenderFeedbackRequestItem[];
  projectToken?: string | null;
}): Promise<HTTPClientResponse> | null => {
  if (!items.length) return null;

  return CIQClient.post<TLinkRecommenderFeedbackResponse>({
    url: `${BASE_URL}${LINK_RECOMMENDER_FEEDBACK_URL}`,
    data: items,
    showError: false,
    config: projectToken
      ? { headers: { Authorization: `Bearer ${projectToken}` } }
      : undefined
  });
};
